import Emitter from "./Emitter";

export default class SoundOn extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: "soundOn" });
    }

    SPINGAMES_handler() {
        this.emitTop({ event: "volume", action: true });
        this.emitParent({ event: "volume", action: true });
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('sound')) {
            let data = {
                _type: "ucip.sound.g2wSoundUpdateNotification",
                mute: false,
                level: 100
            }
            if (this.gb.settings.nativeMobileApp) {
                data.handled = true;
                window.parent.postMessage(JSON.stringify(data));
                
            } else {
                this.emitParent(JSON.stringify(data));
            }
        }
    }

    POKERSTARS_handler() {
        const dataForXc = {
            "msgId":"rg2xcPropertiesUpdated",
            "soundEnabled": true,
        }

        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify(dataForXc), "*");
        }
    }

    LNWOGS_handler() {
        this.gb.wallet.soundOn();
    }

    _default() {
        this.emitParent({ wpgaction: "soundOn.parent" });
        this.emitTop({ wpgaction: "soundOn" });
        this.emitiOS({ wpgaction: "soundOn" });
    }
}
